import TableForPolicy from "../tableForPolicy";
import TableForPrivacy from "../TableForPrivacy";

const PrivacyPolicy = () => {
  return (
    <div className="w-3/4 bg-[#04152d] lg:p-4 text-white leading-8">
      <h2 className="text-[32px] font-bold mb-4">PRIVACY POLICY</h2>
      <br></br>
      This Privacy Policy applies between you, the User of this Website, and
      Atendi Ltd., the owner and provider of this Website. Atendi Ltd. takes the
      privacy of your information very seriously. This Privacy Policy applies to
      our use of any and all Data collected by us or provided by you in relation
      to your use of the Website.
      <br></br>
      <br></br>
      This Privacy Policy should be read alongside, and in addition to, our
      Terms and Conditions, which can be found at: www.motickets.co.uk.
      <br></br>
      <br></br>
      Please read this Privacy Policy carefully.
      <br /> <br></br>
      <h3 className="font-semibold text-xl">Definitions and Interpretation</h3>
      <br></br>
      1. In this Privacy Policy, the following definitions are used:
      <TableForPolicy />
      <br></br>
      2. In this Privacy Policy, unless the context requires a different
      interpretation: <br></br>
      a. the singular includes the plural and vice versa; <br></br>
      b. references to sub-clauses, clauses, schedules or appendices are to
      sub-clauses, clauses, schedules or appendices of this Privacy Policy;{" "}
      <br></br> c. a reference to a person includes firms, companies, government
      entities, trusts and partnerships;<br></br> d. "including" is understood
      to mean "including without limitation";<br></br> e. reference to any
      statutory provision includes any modification or amendment of it;<br></br>{" "}
      f. the headings and sub-headings do not form part of this Privacy Policy.
      <br></br>
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Scope of this Privacy Policy</h3>
      <br></br>
      3. This Privacy Policy applies only to the actions of Atendi Ltd. and
      Users with respect to this Website. It does not extend to any websites
      that can be accessed from this Website including, but not limited to, any
      links we may provide to social media websites. <br></br>
      4. For purposes of the applicable Data Protection Laws, Atendi Ltd. is the
      "data controller". This means that Atendi Ltd. determines the purposes for
      which, and the manner in which, your Data is processed.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Data Collected </h3>
      <br></br>
      5. We may collect the following Data, which includes personal Data, from
      you: <br></br>
      a. name; <br></br>
      b. gender; <br></br>
      c. contact Information such as email addresses and telephone numbers;{" "}
      <br></br>
      d. demographic information such as postcode, preferences and interests;
      <br></br>
      e. IP address (automatically collected);
      <br></br>
      f. __________; in each case, in accordance with this Privacy Policy.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">How We Collect Data </h3>
      <br></br>
      6. We collect Data in the following ways: <br></br>
      a. data is given to us by you; and
      <br></br>
      b. data is collected automatically. <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Data That is Given to Us by You</h3>
      <br></br>
      7. Atendi Ltd. will collect your Data in a number of ways, for example:{" "}
      <br></br>
      a. when you contact us through the Website, by telephone, post, e-mail or
      through any other means;
      <br></br>
      b. when you make payments to us, through this Website or otherwise;
      <br></br>
      c. when you elect to receive marketing communications from us;
      <br></br>
      d. when you use our services;
      <br></br>
      in each case, in accordance with this Privacy Policy.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Data That is Collected Automatically
      </h3>
      <br></br>
      8. To the extent that you access the Website, we will collect your Data
      automatically, for example:
      <br></br>
      a. we automatically collect some information about your visit to the
      Website. This information helps us to make improvements to Website content
      and navigation, and includes your IP address, the date, times and
      frequency with which you access the Website and the way you use and
      interact with its content.
      <br></br>
      b. we will collect your Data automatically via cookies, in line with the
      cookie settings on your browser. For more information about cookies, and
      how we use them on the Website, see the section below, headed "Cookies".
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Our Use of Data</h3>
      <br></br>
      9. Any or all of the above Data may be required by us from time to time in
      order to provide you with the best possible service and experience when
      using our Website. Specifically, Data may be used by us for the following
      reasons:
      <br></br>
      a. internal record keeping;
      <br></br>
      b. improvement of our products / services;
      <br></br>
      c. __________;
      <br></br>
      in each case, in accordance with this Privacy Policy.
      <br></br>
      10. We may use your Data for the above purposes if we deem it necessary to
      do so for our legitimate interests. If you are not satisfied with this,
      you have the right to object in certain circumstances (see the section
      headed "Your rights" below).
      <h3 className="font-semibold text-xl">Who We Share Data With</h3>
      <br></br>
      11. We may share your Data with the following groups of people for the
      following reasons:
      <br></br>
      a. any of our group companies or affiliates - to ensure the proper
      administration of your website and business;
      <br></br>
      b. our employees, agents and/or professional advisors - to obtain advice
      from professional advisers;
      <br></br>
      c. third party payment providers who process payments made over the
      Website - to enable third party payment providers to process user payments
      and refunds;
      <br></br>
      d. relevant authorities - to facilitate detection of crime or the
      collection of taxes or duties; in each case, in accordance with this
      Privacy Policy.
      <br></br>
      <h3 className="font-semibold text-xl">Who We Share Data With</h3>
      <br></br>
      12. We will use technical and organisational measures to safeguard your
      Data, for example:
      <br></br>
      a. access to your account is controlled by a password and a user name that
      is unique to you.
      <br></br>
      b. we store your Data on secure servers.
      <br></br>
      13. Technical and organisational measures include measures to deal with
      any suspected data breach. If you suspect any misuse or loss or
      unauthorised access to your Data, please let us know immediately by
      contacting us via this e-mail address: help@motickets.co.uk.
      <br></br>
      14. If you want detailed information from Get Safe Online on how to
      protect your information and your computers and devices against fraud,
      identity theft, viruses and many other online problems, please visit
      www.getsafeonline.org. Get Safe Online is supported by HM Government and
      leading businesses.
      <br></br>
      <h3 className="font-semibold text-xl">Data Retention</h3>
      <br></br>
      15. Unless a longer retention period is required or permitted by law, we
      will only hold your Data on our systems for the period necessary to fulfil
      the purposes outlined in this Privacy Policy or until you request that the
      Data be deleted.
      <br></br>
      16. Even if we delete your Data, it may persist on backup or archival
      media for legal, tax or regulatory purposes.
      <br></br>
      <h3 className="font-semibold text-xl">Your Rights</h3>
      <br></br>
      17. You have the following rights in relation to your Data:
      <br></br>
      a. Right to access - the right to request (i) copies of the information we
      hold about you at any time, or (ii) that we modify, update or delete such
      information. If we provide you with access to the information we hold
      about you, we will not charge you for this, unless your request is
      "manifestly unfounded or excessive." Where we are legally permitted to do
      so, we may refuse your request. If we refuse your request, we will tell
      you the reasons why.
      <br></br>
      b. Right to correct - the right to have your Data rectified if it is
      inaccurate or incomplete.
      <br></br>
      c. Right to erase - the right to request that we delete or remove your
      Data from our systems.
      <br></br>
      d. Right to restrict our use of your Data - the right to "block" us from
      using your Data or limit the way in which we can use it.
      <br></br>
      e. Right to data portability - the right to request that we move, copy or
      transfer your Data.
      <br></br>
      f. Right to object - the right to object to our use of your Data including
      where we use it for our legitimate interests.
      <br></br>
      18. To make enquiries, exercise any of your rights set out above, or
      withdraw your consent to the processing of your Data (where consent is our
      legal basis for processing your Data), please contact us via this e-mail
      address: help@motickets.co.uk.
      <br></br>
      19. If you are not satisfied with the way a complaint you make in relation
      to your Data is handled by us, you may be able to refer your complaint to
      the relevant data protection authority. For the UK, this is the
      Information Commissioner's Office (ICO). The ICO's contact details can be
      found on their website at https://ico.org.uk/.
      <br></br>
      20. It is important that the Data we hold about you is accurate and
      current. Please keep us informed if your Data changes during the period
      for which we hold it.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Links to Other Websites</h3>
      <br></br>
      21. This Website may, from time to time, provide links to other websites.
      We have no control over such websites and are not responsible for the
      content of these websites. This Privacy Policy does not extend to your use
      of such websites. You are advised to read the Privacy Policy or statement
      of other websites prior to using them.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Changes of Business Ownership and Control
      </h3>
      <br></br>
      22. Atendi Ltd. may, from time to time, expand or reduce our business and
      this may involve the sale and/or the transfer of control of all or part of
      Atendi Ltd.. Data provided by Users will, where it is relevant to any part
      of our business so transferred, be transferred along with that part and
      the new owner or newly controlling party will, under the terms of this
      Privacy Policy, be permitted to use the Data for the purposes for which it
      was originally supplied to us.
      <br></br>
      23. We may also disclose Data to a prospective purchaser of our business
      or any part of it.
      <br></br>
      24. In the above instances, we will take steps with the aim of ensuring
      your privacy is protected.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Cookies </h3>
      <br></br>
      25. This Website may place and access certain Cookies on your computer.
      Atendi Ltd. uses Cookies to improve your experience of using the Website
      and to improve our range of products. Atendi Ltd. has carefully chosen
      these Cookies and has taken steps to ensure that your privacy is protected
      and respected at all times.
      <br></br>
      26. All Cookies used by this Website are used in accordance with current
      UK and EU Cookie Law.
      <br></br>
      27. Before the Website places Cookies on your computer, you will be
      presented with a message bar requesting your consent to set those Cookies.
      By giving your consent to the placing of Cookies, you are enabling Atendi
      Ltd. to provide a better experience and service to you. You may, if you
      wish, deny consent to the placing of Cookies; however certain features of
      the Website may not function fully or as intended.
      <br></br>
      28. This Website may place the following Cookies:
      <TableForPrivacy />
      <br></br>
      29. You can find a list of Cookies that we use in the Cookies Schedule.
      <br></br>
      30. You can choose to enable or disable Cookies in your internet browser.
      By default, most internet browsers accept Cookies but this can be changed.
      For further details, please see the help menu in your internet browser.
      You can switch off Cookies at any time, however, you may lose any
      information that enables you to access the Website more quickly and
      efficiently.
      <br></br>
      31. You can choose to delete Cookies at any time; however, you may lose
      any information that enables you to access the Website more quickly and
      efficiently including, but not limited to, personalisation settings.
      <br></br>
      32. It is recommended that you ensure that your internet browser is
      up-to-date and that you consult the help and guidance provided by the
      developer of your internet browser if you are unsure about adjusting your
      privacy settings.
      <br></br>
      33. For more information generally on cookies, including how to disable
      them, please refer to aboutcookies.org. You will also find details on how
      to delete cookies from your computer.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">General </h3>
      <br></br>
      34. You may not transfer any of your rights under this Privacy Policy to
      any other person. We may transfer our rights under this Privacy Policy
      where we reasonably believe your rights will not be affected.
      <br></br>
      35. If any court or competent authority finds that any provision of this
      Privacy Policy (or part of any provision) is invalid, illegal or
      unenforceable, that provision or part-provision will, to the extent
      required, be deemed to be deleted, and the validity and enforceability of
      the other provisions of this Privacy Policy will not be affected.
      <br></br>
      36. Unless otherwise agreed, no delay, act or omission by a party in
      exercising any right or remedy will be deemed a waiver of that, or any
      other, right or remedy.
      <br></br>
      37. This Agreement will be governed by and interpreted according to the
      law of England and Wales. All disputes arising under the Agreement will be
      subject to the exclusive jurisdiction of the English and Welsh courts.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Changes to This Privacy Policy </h3>
      <br></br>
      38. Atendi Ltd. reserves the right to change this Privacy Policy as we may
      deem necessary from time to time or as may be required by law. Any changes
      will be immediately posted on the Website and you are deemed to have
      accepted the terms of the Privacy Policy on your first use of the Website
      following the alterations. You may contact Atendi Ltd. by email at
      help@motickets.co.uk.
      <br></br>
      <br></br>
      This Privacy Policy was created on 01 February 2024.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Cookies </h3>
      <br></br>
      Below is a list of the cookies that we use. We have tried to ensure this
      is complete and up to date, but if you think that we have missed a cookie
      or there is any discrepancy, please let us know.
      <br></br>
      <br></br>
      Strictly necessary
      <br></br>
      <br></br>
      We use the following strictly necessary cookies:
      <br></br>
      <div className=" mx-auto p-4 contain">
        <table className=" bg-white border border-gray-300 ">
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Purpose
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-gray-100 border-b text-black">
              <td className="px-6 py-4 whitespace-wrap">
                We use this session cookie to remember you and maintain your
                session whilst you are using our website
              </td>
              <td className="px-6 py-4 whitespace-wrap">
                We use this session cookie to remember you and maintain your
                session whilst you are using our website{" "}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br></br>
      <h3 className="font-semibold text-xl">Functionality </h3>
      <br></br>
      We use the following functionality cookies:
      <br></br>
      <div className=" mx-auto p-4 contain">
        <table className=" bg-white border border-gray-300 ">
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Purpose
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-gray-100 border-b text-black">
              <td className="px-6 py-4 whitespace-wrap">
                We use this cookie to identify your computer and analyse traffic
                patterns on our website
              </td>
              <td className="px-6 py-4 whitespace-wrap">
                We use this cookie to identify your computer and analyse traffic
                patterns on our website
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Cookies </h3>
      <br></br>
      We use the following analytical/performance cookies:
      <br></br>
      <div className=" mx-auto p-4 contain">
        <table className=" bg-white border border-gray-300 ">
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                Purpose
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-gray-100 border-b text-black">
              <td className="px-6 py-4 whitespace-wrap">
                We use this cookie to help us analyse how users use the website.
              </td>
              <td className="px-6 py-4 whitespace-wrap">
                We use this cookie to help us analyse how users use the website.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
